import  React from 'react'
import { components } from 'react-select'
import AsyncSelect from "react-select/async";
import { FormItem, FormItemProps } from './FormItem'
import { IField, getRequiredError } from './FieldValidation'
import { Option } from './Options'
import { selectStyles } from './SelectField'
import { ErrorText } from './ErrorText'
import { IndustryController } from '../../controllers/IndustryController'

export interface CommodityFieldMultiProps extends FormItemProps {
  id: string
  onChange: { (value: Option<string>[]): any },
  value: Option<string>[],
  required?: boolean
  requiredMessage?: string
  disabled?: boolean
  maxSelection?: number
}

export interface CommodityFieldMultiState {
    defaultOptions?: Option<string>[]
    errorText?: string
}

export class CommodityFieldMulti extends React.Component<CommodityFieldMultiProps, CommodityFieldMultiState> implements IField {
  input: React.RefObject<any> = React.createRef();

    ajax: IndustryController

    constructor(props?: CommodityFieldMultiProps, context?: any) {
      super(props, context)
      this.ajax = new IndustryController()

      this.state = {
      }
    }

    componentDidMount() {
      this.load()
    }

    componentDidUpdate(prevProps: CommodityFieldMultiProps) {
      if (this.props.value != prevProps.value) {
        if (this.state.errorText) {
          this.validate(() => { })
        }
      }
    }

    componentWillUnmount() {
      this.ajax.cancel()
    }

    hasValue(): boolean {
      let res = false
      if (this.props.value) {
        if (this.props.value.length > 0) {
          res = true
        }
      }
      return res
    }

    getErrorText(): string {
      if (this.props.required === true) {
        if (!this.hasValue()) {
          return getRequiredError(this.props)
        }
      }
      return null
    }

    setError(errorText?: string, callback?: { (): any }) {
      this.setState({ errorText }, callback)
    }

    load = () => {
      this.ajax.cancel()
      this.setState({ defaultOptions: [] })
    }

    search = (input: string, callback: ((options: Option<string>[]) => void)) => {
      this.ajax.cancel()

      this.ajax.getCommodityMatches(null, input, (res) => {
        callback(res)
      })
    }

    handleOnChange = (o: Option<string>[]) => {
      const { onChange } = this.props
      onChange(o)
    }

    validate(callback: { (res: boolean): any }, focus?: boolean) {
      const errorText = this.getErrorText()

      this.setError(errorText, () => {
        if (this.props.errorMessage || errorText) {
          if (focus === true) {
            this.focus()
          }
        }
        callback && callback(!((this.props.errorMessage || errorText)))
      })
    }

    focus() {
      if (this.input.current) {
        const selectElement = this.input.current as any;
        if (selectElement && selectElement.focus) {
            selectElement.focus();
        }
    }
    }

    render() {
      const {
        preview, value, id, maxSelection,
      } = this.props
      const { errorText, defaultOptions } = this.state
      const POSITION = 'relative'

      if (preview) {
        let temp = ''
        value.forEach((v) => {
          if (temp.length > 0) {
            temp += ', '
          }
          temp += v.label
        })

        return (
          <FormItem {...this.props} errorMessage={errorText}>
            <div className="form-value">{temp || '--'}</div>
          </FormItem>
        )
      }

      const Menu = (props: any) => {
        const optionSelectedLength = props.getValue().length || 0
        if (maxSelection) {
          return (
            <components.Menu {...props}>
              {optionSelectedLength < maxSelection ? (
                props.children
              ) : (
                <div className="multiselect-maxLimit">
                  {`You can select up to ${maxSelection} commodities.`}
                </div>
              )}
            </components.Menu>
          )
        }
        return (
          <components.Menu {...props}>
            { props.children }
          </components.Menu>
        )
      }

      return (
        <FormItem {...this.props} inputId={id}>
          <AsyncSelect
            styles={selectStyles(true, !!errorText, POSITION)}
            id={id}
            placeholder="Search..."
            ref={ this.input}
            value={value}
            isClearable
            onChange={(v: Option<string>[]) => this.handleOnChange(v)}
            loadOptions={this.search}
            defaultOptions={defaultOptions}
            isMulti
            components={{ Menu }}
          />
          <ErrorText text={errorText} />
        </FormItem>
      )
    }
}
